import { faFilePdf } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FileSaver from "file-saver";
import { get, isEmpty, isNull } from "lodash";
import moment from "moment";
import React, { Suspense } from "react";
import { CsplTable as Table, AddToolTip } from "../../../../components";
import { DownloadloanRepaymentSchedule } from "../../../../services";
import {
  getNullTableItem,
  sortArrayOfObjects,
  usCurrency,
  usDateFormat,
} from "../../../../utils";
import ModificationDetails from "./ModificationDetails";
import { Link } from "react-router-dom";

const columns = [
  {
    label: "Installment",
    className: "column-installment",
    columnName: "installmentNumber",
  },
  {
    label: "Actual Repayment Details",
    className: "column-actual-repayment",
    columnName: "amount",
  },
  {
    label: "Principle Paid",
    className: "column-principal",
    columnName: "principal",
  },
  {
    label: "Interest Paid",
    className: "column-interest",
    columnName: "interest",
  },
  {
    label: "Outstanding Principal",
    className: "column-outstanding",
    columnName: "totalOutstandingPrincipal",
  },
  {
    label: "Repayment Mode",
    className: "column-repayment-mode",
    columnName: "repaymentMode",
  },
];

const RepaymentSchedule = ({ repaymentData = [], loanData }) => {
  const loanAmount = loanData?.requestedAmount;
  let installment = 0;
  // let sortedRepaymentData = sortArrayOfObjects(
  //   repaymentData,
  //   "repaymentDate",
  //   "asc"
  // );

  // repaymentData = repaymentData.map((itm, index, array) => {
  //   if (index == 0) {
  //     repaymentData[index].totalOutstandingPrincipal =
  //       loanAmount - repaymentData[index].principal;
  //     return itm;
  //   }
  //   repaymentData[index].totalOutstandingPrincipal =
  //     repaymentData[index - 1].totalOutstandingPrincipal -
  //     repaymentData[index].principal;
  //   return itm;
  // });

  console.log(repaymentData, "repaymentData");

  return (
    <div className="loan-page-scroll ml-3 mt-2">
      <div className="d-flex justify-content-between align-items-baseline mb-1">
        <div className="ft-14 fw-500">Repayment Schedule</div>
        <div className="ft-12">
          <FontAwesomeIcon
            color={"#C4061A"}
            className={"ft-16 mr-2"}
            icon={faFilePdf}
          />
          <Link
            onClick={() => {
              const val = { LoanId: 5 };
              val.LoanId = loanData.id;
              DownloadloanRepaymentSchedule(val)
                .then((response) => {
                  // console.log("kiran",response)
                  var blob = new Blob([response], {
                    type: "application/pdf",
                  });
                  FileSaver.saveAs(
                    blob,
                    "Actual Repayment Schedule -" + loanData.loanIdentifier + ""
                  );
                })
                .catch((error) => {});
            }}
            className="loan-anchor-color cursor-pointer"
          >
            Download
          </Link>
        </div>
      </div>
      <div className="loan-repayment-table">
        <Table>
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {!isEmpty(repaymentData) ? (
              repaymentData.map((data, index) => {
                return isNull(data.reAmortizationRequestDetails) &&
                  isNull(data.loanSuspension) ? (
                  <Table.Tr key={index}>
                    {columns.map((item, cellIndex) => {
                      const getContent = () => {
                        if (item.columnName == "installmentNumber") {
                          return data.reAmortizationRequestDetails == null &&
                            data.loanSuspension == null
                            ? ++installment
                            : null;
                        }
                        if (
                          [
                            "principal",
                            "interest",
                            "totalOutstandingPrincipal",
                          ].includes(item.columnName)
                        ) {
                          return usCurrency(data[item.columnName]);
                        }
                        if (item.columnName == "amount") {
                          return (
                            <div className="d-flex flex-column m-0">
                              <p className="m-0">
                                {usCurrency(data[item.columnName])}
                              </p>
                              <p className="m-0">
                                {usDateFormat(data["repaymentDate"])}
                              </p>
                            </div>
                          );
                        }
                        if (item.columnName == "repaymentMode") {
                          return "Payroll deduction";
                        }

                        return data[item.columnName];
                      };

                      return (
                        <Table.Td key={cellIndex} className={item.className}>
                          {getNullTableItem(getContent())}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                ) : (
                  <Table.Tr key={index}>
                    <ModificationDetails
                      loanActivationDate={loanData.loanActivationDate}
                      data={data}
                    />
                  </Table.Tr>
                );
              })
            ) : (
              <div class="d-flex align-items-center justify-content-center">
                No Records Found
              </div>
            )}
          </Table.Tbody>
        </Table>
      </div>
    </div>
  );
};

export default RepaymentSchedule;
